import script from "./CTicketIcon.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTicketIcon.vue?vue&type=script&setup=true&lang=ts"

import "./CTicketIcon.vue?vue&type=style&index=0&id=7878523b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7878523b"]])

export default __exports__